export default {
  language: { is: 'Tungumál', en: 'Language' },
  login: { is: 'Netbankar', en: 'Login' },
  search: { is: 'Leit', en: 'Search' },
  closeNavigation: { is: 'Loka valmynd', en: 'Close navigation' },
};
